<template>
  <!-- 保存模块对话框 -->
  <el-dialog title="资源库" :visible.sync="visibleVal" :append-to-body="true" custom-class="imgResDialog">
    <div slot="title" class="dialog-header">
      <span class="dialog-title">资源库</span>
      <div class="search-box">
        <input type="text" placeholder="搜索" v-model="searchContent" @keypress="enterFun($event)" />
        <i class="clear-btn icon-portal-close-one" @click="searchContent = ''" v-show="searchContent.trim().length > 0"></i>
        <i class="search-btn icon-portal-search" @click="searchImgHandle"></i>
      </div>
    </div>
    <div class="img-left-menu">
      <div
        class="menu-item"
        v-for="(item, index) in leftMenuList"
        :key="index"
        :class="[leftMenuActiveIndex == item.id ? 'active' : '']"
        @click="leftMenuActiveHandle(item, index)"
      >
        {{ item.name }}
      </div>
      <div class="menu-item" :class="[leftMenuActiveIndex == -1 ? 'active' : '']" @click="leftMenuActiveHandle(-1, -1)">
        我上传的
      </div>
      <div class="left-menu-bottom-btns">
        <div class="local-upload-btn">
          <i class="icon-portal-upload2"></i>
          <input type="file" accept="image/gif,image/jpeg,image/jpg,image/png" @change="upMyloadImg($event)" />
          本地上传
        </div>
        <a href="https://ps.mh.chaoxing.com/#/template/list" target="_blank" class="online-design-btn"
          ><i class="icon-portal-pen-tool"></i>在线设计</a
        >
      </div>
    </div>
    <div class="img-right-list">
      <div class="right-catetory" :class="[rightCatetorySlideStatus ? 'isDown' : '']" v-if="leftMenuActiveIndex !== -1">
        <div class="slide-down-btn" @click="rightCatetorySlideStatus = !rightCatetorySlideStatus">
          <i class="icon-Union-12"></i>
        </div>
        <div class="right-filter" v-if="leftMenuActiveIndex == imgId">
          <div class="filter-box">
            <i class="icon icon-portal-orientation"></i>
            <el-select
              v-model="imgScale"
              clearable
              popper-class="filter"
              placeholder="比例"
              @change="catetorySelectChange('img', imgScale, imgColor)"
            >
              <el-option
                v-for="(item, index) in scallList"
                :key="index"
                :selected="imgScale == item.value"
                :value="item.value"
                :label="item.title"
                >{{ item.title }}
              </el-option>
            </el-select>
          </div>
          <div class="filter-box">
            <img class="color-img" v-if="!imgColor" src="../../assets/images/color.png" alt="" />
            <i class="color-ball" v-else :style="{ background: selectColor[0].value }"></i>
            <el-select
              v-model="imgColor"
              clearable
              popper-class="filter color-box"
              placeholder="颜色"
              @change="catetorySelectChange('img', imgScale, imgColor)"
            >
              <el-option
                v-for="(item, index) in colorList"
                :key="index"
                :selected="imgColor == item.value"
                :value="item.title"
                :label="item.title"
              >
                <el-tooltip class="item" effect="dark" :content="item.title" placement="top" :open-delay="1000">
                  <span class="color-solid" :style="{ background: item.value }"></span>
                </el-tooltip>
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="right-filter" v-if="leftMenuActiveIndex == iconId">
          <div class="filter-box color-set" v-if="iconStyle != '多色图标'">
            <color-picker class="color-picker flex1" :color.sync="setIconColor"></color-picker>
            <span class="text">颜色</span>
          </div>
          <div class="filter-box">
            <i class="icon icon-portal-style1"></i>
            <el-select
              v-model="iconStyle"
              clearable
              popper-class="filter"
              placeholder="风格"
              @change="catetorySelectChange('icon', iconClassify, iconStyle)"
            >
              <el-option
                v-for="(item, index) in styleList"
                :key="index"
                :selected="iconStyle == item.value"
                :value="item.title"
                :label="item.title"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <span
          class="cate-item"
          :class="[rightCatetoryActiveIndex == 0 ? 'active' : '']"
          @click="rightCatetoryActiveHandle('', '')"
          >全部</span
        >
        <span
          class="cate-item"
          v-for="(item, index) in rightCatetoryList"
          :key="index"
          :class="[rightCatetoryActiveIndex == item.id ? 'active' : '']"
          @click="rightCatetoryActiveHandle(item.id, item.name)"
          >{{ item.name }}
        </span>
      </div>
      <div
        class="right-empty-list"
        v-if="
          (leftMenuActiveIndex == imgId && rightImgList.length == 0 && searchResultLength < 1) ||
          (leftMenuActiveIndex == iconId && rightIconList.length == 0 && searchResultLength < 1) ||
          (leftMenuActiveIndex == -1 && rightImgList.length == 0 && searchResultLength < 1)
        "
      >
        <img src="../../assets/images/img-null-data-light.png" alt="" />
        <p v-if="searchContent">暂无搜索结果</p>
        <p v-else>暂无内容</p>
      </div>
      <div class="scrollbar" v-else>
        <el-scrollbar
          style="height: calc(100% - 40px)"
          ref="scrollbar"
          v-if="leftMenuActiveIndex == imgId || leftMenuActiveIndex == -1"
        >
          <!-- 图片-->
          <div class="right-img-list">
            <waterfall
              :col="col"
              :data="rightImgList"
              @loadmore="pageNumChangeHandle"
              :lazy-distance="20"
              :load-distance="200"
              :gutterWidth="gutterWidth"
            >
              <template>
                <div
                  class="img-item-wrap"
                  v-for="(item, index) in rightImgList"
                  :key="index"
                  @click="chooseImgHandle(item)"
                >
                  <div class="img-item">
                    <span class="img-msg-icon icon-portal-info2">
                      <div class="img-msg-dialog">
                        <h4 class="img-name">{{ item.name }}</h4>
                        <div class="img-msg-box">
                          <div class="msg-item">
                            <span class="msg-t">尺寸：</span>
                            <span class="msg-v">{{ item.content.size }}</span>
                          </div>
                          <div class="msg-item">
                            <span class="msg-t">格式：</span>
                            <span class="msg-v">{{ item.content.format }}</span>
                          </div>
                          <div class="msg-item">
                            <span class="msg-t">大小：</span>
                            <span class="msg-v">{{ item.content.length }}</span>
                          </div>
                        </div>
                      </div>
                    </span>
                    <img v-if="item.content.url" :src="item.content.url" :lazy-src="item.content.url" alt="" />
                    <el-tooltip class="item" effect="dark" content="删除" placement="top" :open-delay="1000">
                      <span
                        class="img-msg-delete"
                        v-show="leftMenuActiveIndex == -1"
                        @click.stop="delMyUploadImg(item)"
                      >
                        <i class="icon-portal-delete1"></i>
                      </span>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="在线设计" placement="top" :open-delay="1000">
                      <span v-if="leftMenuActiveIndex != -1" class="to-ps icon-portal-pen-tool" @click="toPs(item)"></span>
                    </el-tooltip>
                  </div>
                  <p>{{ item.content.size }}</p>
                </div>
              </template>
            </waterfall>
          </div>
        </el-scrollbar>
        <el-scrollbar style="height: calc(100% - 80px)" v-if="leftMenuActiveIndex == iconId">
          <!-- 图标-->
          <ul class="icon-boxs" @mousedown.stop>
            <li
              class="icon-box"
              v-for="(item, index) in rightIconList"
              :key="index"
              @click.stop="chooseCurrentIconHandle(item)"
            >
              <el-tooltip class="item" effect="dark" :content="item.name" placement="bottom" :open-delay="500">
                <span v-html="item.content" :style="getIconColor"></span>
              </el-tooltip>
            </li>
          </ul>
        </el-scrollbar>
        <p class="loading" v-if="loading"><i class="icon-portal-loading"></i>加载中...</p>
        <p class="iconpark-tips" v-if="leftMenuActiveIndex == iconId">
          —— 所有内容均来自<span>IconPark</span>，版权归作者及来源网站所有 ——
        </p>
        <el-pagination
          v-if="leftMenuActiveIndex == iconId"
          :hide-on-single-page="true"
          background
          layout="prev, pager, next"
          @current-change="pageNumChangeHandle"
          :page-size="pageSize"
          :total="totalNum"
        >
        </el-pagination>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import "../common.css"
import publicData from "../mixins/publicData.js"
import primaryImg from "assets/images/primaryImage.png"
import emptyImg from "assets/images/empty_img_bg.png"
import { uploadResources } from "../../utils"
import instance from "../../interceptor"
import { withMethodsHistoryCombine } from "utils/revork"
import { parseColorString } from "../../utils/parseColor"

export default withMethodsHistoryCombine({
  mixins: [publicData],
  name: "resourceLib",
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    imgSrc: {
      type: String,
      required: false
    },
    defaultImg: {
      type: String,
      required: false
    },
    themeKey: {
      type: String,
      required: false
    },
    //10 1.0素材     11大屏背景   12大屏图片  13布局背景    14其他
    imgType: {
      type: String,
      required: false
    },
    size: {
      type: String,
      default: "small",
      required: false
    },
    noImgLib: {
      type: Boolean,
      default: true,
      required: false
    },
    imgSize: {
      type: String,
      default: "1920*220",
      required: false
    },
    iconColor: {
      type: [String, Object],
      default: "#444444",
      required: false
    },
    iconType: {
      type: String,
      required: false
    },
    resInfo: {
      type: Object,
      required: false
    },
    // 默认类型：image、icon
    defaultType: {
      type: String,
      default: "image",
      required: false
    }
  },
  data() {
    return {
      contextPath: "",
      classify: [],
      // wfwfid: undefined,
      imgList: [],
      noImg: true,
      leftMenuList: [],
      leftMenuActiveIndex: 0,
      leftMenuCurrentIndex: 0,
      rightCatetoryList: [],
      rightImgCatetoryList: [],
      imgId: null, //数据库中存储的图片库的id
      iconId: null, //数据库中存储的图标库的id
      rightIconCatetoryList: [
        { id: 1, name: "线性" },
        { id: 2, name: "面性" },
        { id: 3, name: "扁平" },
        { id: 4, name: "磨砂质感" },
        { id: 5, name: "精美" }
      ],
      rightImgList: [],
      rightCatetoryActiveIndex: -1,
      rightCatetorySlideStatus: false,
      searchContent: "",
      searchResultLength: -1,
      totalNum: 0,
      rightIconList: [],
      col: 4,
      pageSize: 20,
      imgScale: "",
      scallList: [
        { value: "横向", title: "横向" },
        { value: "纵向", title: "纵向" },
        { value: "正方形", title: "正方形" }
      ],
      imgColor: "",
      colorList: [
        { value: "#000000", title: "黑色" },
        { value: "#FFFFFF", title: "白色" },
        { value: "#A3AFB7", title: "灰色" },
        { value: "#FFEE45", title: "黄色" },
        { value: "#EE812B", title: "橙色" },
        { value: "#5CD7DD", title: "青色" },
        { value: "#1F974B", title: "绿色" },
        { value: "#FC1520", title: "红色" },
        { value: "#FDADDA", title: "粉色" },
        { value: "#5F35F8", title: "紫色" },
        { value: "#5495FF", title: "蓝色" }
      ],
      iconClassify: "",
      iconStyle: "",
      styleList: [
        { value: "单色图标", title: "单色图标" },
        { value: "多色图标", title: "多色图标" }
      ],
      loading: false,
      pageNum: 1,
      totalPage: 1
    }
  },
  computed: {
    itemWidth() {
      return 133 * 0.5 * (document.getElementsByClassName("imgResDialog")[0].clientWidth / 375)
    },
    gutterWidth() {
      return 10 * 0.5 * (document.getElementsByClassName("imgResDialog")[0].clientWidth / 375)
    },
    visibleVal: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit("update:visible", val)
        if (!val) {
          sessionStorage.removeItem("openResourceLib")
        }
      }
    },
    imgVal: {
      get() {
        this.noImg = this.imgSrc.length === 0 ? true : false

        return this.imgSrc.length ? this.imgSrc : request_prefix === "bigScreen" ? emptyImg : primaryImg
      },
      set(val) {
        this.$emit("update:imgSrc", val)
      }
    },
    wfwfid() {
      return this.$store.state.states.getDataPageIds.wfwfid
    },
    selectColor() {
      let _this = this
      return _this.colorList.filter(function (item) {
        return item.title == _this.imgColor
      })
    },
    setIconColor: {
      get() {
        if (this.iconColor.color) return this.iconColor.color
        else return this.iconColor || ""
      },
      set(val) {
        this.$emit("update:iconColor", val)
      }
    },
    getIconColor() {
      let color = this.$parseColor(this.iconColor || "")
      color = parseColorString(color)
      console.log("color",color)
      if(color.toLowerCase().indexOf("ffffff")>-1 || color.toLowerCase() === '#fff' ) {
        color = ''
      }
      return {
        "--iconColor": color
      }
    },
    iconTypeVal: {
      get() {
        return this.iconType
      },
      set(val) {
        this.$emit("update:iconType", val)
      }
    },
    resInfoVal: {
      get() {
        return this.resInfo
      },
      set(val) {
        this.$emit("update:resInfo", val)
      }
    }
  },
  watch: {
    visible(newVal, oldVal) {
      if (newVal) {
        this.openImgLib()
        this.leftMenuList = []
      }
    }
  },
  mounted() {
    this.contextPath = window.hasOwnProperty("p_contextpath") ? window["p_contextpath"] : ""
  },
  methods: {
    uploadImg(e) {
      let file = e.target.files[0]
      let _this = this
      uploadResources(file, 5, this, function (imgSrc) {
        _this.imgVal = imgSrc
      })
    },
    delBgImage() {
      this.imgVal = ""
    },
    openImgLib() {
      this.getImgAllTypes()
      this.getIconAllTypes()
      if (this.defaultType === "image") {
        setTimeout(() => {
          this.listenerScroll()
        }, 1000)
      }
    },
    getImgLists() {
      instance
        .get(this.contextPath + "material/list", {
          params: {
            wfwfid: this.wfwfid,
            type: Number(this.imgType),
            color: 0 //不分颜色
          }
        })
        .then(res => {
          if (res.data.code === 1) {
            this.$set(this, "imgList", res.data.data.list)
          }
        })
    },
    pageNumChangeHandle(page) {
      switch (this.leftMenuActiveIndex) {
        case this.imgId:
          // 图片库
          this.getRightImgList(this.leftMenuActiveIndex, this.rightCatetoryActiveIndex, page, "")
          break
        case this.iconId:
          // 图标库
          this.getRightIconList(this.leftMenuActiveIndex, this.rightCatetoryActiveIndex, page, null)
          break
        default:
      }
    },
    // 获取所有图标分类
    getIconAllTypes() {
      this.instance
        .get(this.contextPath + "v2/resource/all-classify?type=2", {
          wfwfid: this.wfwfid
        })
        .then(res => {
          if (res.data.code === 1) {
            this.leftMenuList.push(res.data.data[0])
            this.iconId = res.data.data[0].id
            if (this.defaultType === "icon") {
              this.leftMenuActiveIndex = this.iconId
              this.pageSize = 80
              this.rightCatetoryList = this.rightIconCatetoryList
              this.getRightIconList(this.iconId, "", "", "", this.iconClassify, this.iconStyle)
            }
          }
        })
    },
    // 获取所有图片分类
    getImgAllTypes() {
      this.instance
        .get(this.contextPath + "v2/resource/all-classify?type=1", {
          wfwfid: this.wfwfid
        })
        .then(res => {
          if (res.data.code === 1) {
            this.leftMenuList.unshift(res.data.data[0])
            this.imgId = res.data.data[0].id
            if (this.defaultType === "image") {
              this.leftMenuActiveIndex = this.imgId
            }
            if (this.rightCatetoryActiveIndex == -1) {
              this.rightCatetoryActiveIndex = ""
            }
            if (this.leftMenuCurrentIndex === 0 && this.defaultType === "image") {
              this.rightImgCatetoryList = res.data.data[this.leftMenuCurrentIndex].subClassify
              this.rightCatetoryList = this.rightImgCatetoryList
              this.getRightImgList(this.imgId, this.rightCatetoryActiveIndex, "", "", this.imgScale, this.imgColor)
            } else if (this.leftMenuCurrentIndex === -1 && this.defaultType === "image") {
              this.getMyUploadImg()
            }
          }
        })
    },
    getRightImgList(firstClassifyId, secondClassifyId, pageNum, tag, scale, color) {
      tag = typeof tag == "undefined" ? "" : tag ? tag : this.searchContent.trim()
      this.instance
        .get(this.contextPath + "v2/resource/query-by-classify", {
          params: {
            wfwfid: this.wfwfid,
            firstClassifyId: firstClassifyId,
            secondClassifyId: secondClassifyId,
            pageNum: pageNum || 1,
            pageSize: this.pageSize,
            tag: tag,
            scale: scale,
            color: color
          }
        })
        .then(res => {
          if (res.data.code === 1) {
            for (let i = 0; i < res.data.data.list.length; i++) {
              res.data.data.list[i].content = JSON.parse(res.data.data.list[i].content)
            }
            this.rightImgList = res.data.data.list
            this.totalNum = res.data.data.total
            this.totalPage = res.data.data.pages
            this.pageNum = 1
            if (tag.length !== 0 && res.data.data.list.length == 0) {
              this.searchResultLength = 0
            } else {
              this.searchResultLength = -1
            }
          }
        })
    },
    getRightIconList(firstClassifyId, secondClassifyId, pageNum, tag, classify, style) {
      this.instance
        .get(this.contextPath + "v2/resource/query-by-classify", {
          params: {
            wfwfid: this.wfwfid,
            firstClassifyId: firstClassifyId,
            secondClassifyId: secondClassifyId == -1 ? null : secondClassifyId,
            pageNum: pageNum,
            pageSize: this.pageSize,
            tag: tag ? tag : this.searchContent.trim(),
            classify: classify,
            style: style
          }
        })
        .then(res => {
          if (res.data.code === 1) {
            this.rightIconList = res.data.data.list
            this.totalNum = res.data.data.total
          }
        })
    },
    // 上传图片
    upMyloadImg(e) {
      let file = e.target.files[0]
      let formData = new FormData()
      formData.append("file", file)
      const openResourceLib = sessionStorage.getItem("openResourceLib")
      this.instance.post(this.contextPath + "v2/resource/upload-img", formData).then(res => {
        if (res.data.code === 1) {
          this.getMyUploadImg()
          this.leftMenuActiveHandle(-1, -1)
          e.srcElement.value = ""
          if (openResourceLib === "true" && res.data.data) {
            // 产品需求 由快捷菜单打开的资源库上传图片时同步修改背景图
            this.imgVal = res.data.data
            this.visibleVal = false
          }
        } else {
          this.$message("上传失败！")
          if (openResourceLib === "true") {
            this.visibleVal = false
          }
        }
      })
    },
    // 切换到图片库
    leftMenuActiveHandle(value, index) {
      this.leftMenuCurrentIndex = index
      if (value == -1) {
        this.leftMenuActiveIndex = value
        this.getMyUploadImg()
      } else {
        this.leftMenuActiveIndex = value.id
        this.rightCatetoryActiveIndex = ""
        this.rightCatetoryList = value.subClassify
        switch (value.id) {
          case this.imgId:
            // 图片库
            this.pageSize = 20
            this.getRightImgList(value.id, "", "", "", this.imgScale, this.imgColor)
            setTimeout(() => {
              this.listenerScroll()
            }, 1000)
            break
          case this.iconId:
            // 图标库
            this.pageSize = 80
            this.rightCatetoryList = this.rightIconCatetoryList
            this.getRightIconList(value.id, "", "", "", this.iconClassify, this.iconStyle)
            break
          default:
        }
      }
    },
    rightCatetoryActiveHandle(index, name) {
      this.rightCatetoryActiveIndex = index
      switch (this.leftMenuActiveIndex) {
        case this.imgId:
          this.getRightImgList(
            this.leftMenuActiveIndex,
            this.rightCatetoryActiveIndex,
            "",
            "",
            this.imgScale,
            this.imgColor
          )
          break
        case this.iconId:
          this.getRightIconList(this.leftMenuActiveIndex, "", "", "", name, this.iconStyle)
          break
        default:
      }
    },
    getMyUploadImg() {
      const _this = this
      this.instance
        .get(this.contextPath + "v2/resource/query-my-upload", {
          params: {
            pageSize: this.pageSize
          }
        })
        .then(res => {
          if (res.data.code === 1) {
            for (let i = 0; i < res.data.data.list.length; i++) {
              res.data.data.list[i].content = JSON.parse(res.data.data.list[i].content)
              // res.data.data.list[i].content.url = "http://mh.chaoxing.com" + res.data.data.list[i].content.url
            }
            this.pageNum = res.data.data.pageNum
            this.totalPage = res.data.data.pages
            this.totalNum = res.data.data.total
            this.rightImgList = res.data.data.list
            _this.getMoreMyUploadImg()
          }
        })
    },
    // 删除
    delMyUploadImg(item) {
      let formData = new FormData()
      formData.append("id", item.id)
      this.instance.post(this.contextPath + "v2/resource/delete-resource", formData).then(res => {
        if (res.data.code === 1) {
          this.$message({
            type: "success",
            duration: 2000,
            message: "删除成功"
          })
          this.getMyUploadImg()
        }
      })
    },
    chooseImgHandle(item) {
      this.iconTypeVal = "img"
      this.imgVal = item.content.url
      this.visibleVal = false
      this.resInfoVal = item
    },
    // 搜索
    searchImgHandle() {
      switch (this.leftMenuActiveIndex) {
        case this.imgId:
          this.getRightImgList(
            this.leftMenuActiveIndex,
            this.rightCatetoryActiveIndex,
            "",
            this.searchContent.trim(),
            this.imgScale,
            this.imgColor
          )
          break
        case this.iconId:
          this.getRightIconList(
            this.leftMenuActiveIndex,
            this.rightCatetoryActiveIndex,
            "",
            this.searchContent.trim(),
            this.iconClassify,
            this.iconStyle
          )
          break
        default:
      }
    },
    // 回车搜索
    enterFun(e) {
      if (e.keyCode == "13") {
        this.searchImgHandle()
      }
    },
    // 下拉筛选
    catetorySelectChange(type, value1, value2, value3) {
      switch (type) {
        case "img":
          this.getRightImgList(this.leftMenuActiveIndex, this.rightCatetoryActiveIndex, "", "", value1, value2)
          break
        case "icon":
          this.getRightIconList(this.leftMenuActiveIndex, this.rightCatetoryActiveIndex, "", "", value1, value2, value3)
          break
        default:
      }
    },
    chooseCurrentIconHandle(item) {
      this.iconTypeVal = "icon"
      this.imgVal = item.encrypt
      this.visibleVal = false
      this.resInfoVal = item
    },
    listenerScroll() {
      let _this = this
      _this.$refs.scrollbar.wrap.onscroll = e => {
        let height = e.target.scrollHeight - e.target.clientHeight
        if (
          (height == e.target.scrollTop || height - e.target.scrollTop === 1) &&
          height != 0 &&
          _this.leftMenuActiveIndex === _this.imgId
        ) {
          if (_this.pageNum < this.totalPage + 1) {
            _this.loading = true
            _this.pageNum++
            _this.instance
              .get(_this.contextPath + "v2/resource/query-by-classify", {
                params: {
                  wfwfid: _this.wfwfid,
                  firstClassifyId: _this.leftMenuActiveIndex,
                  secondClassifyId: _this.rightCatetoryActiveIndex,
                  pageNum: _this.pageNum,
                  pageSize: _this.pageSize,
                  tag: "",
                  scale: _this.imgScale,
                  color: _this.imgColor
                }
              })
              .then(res => {
                if (res.data.code === 1) {
                  for (let i = 0; i < res.data.data.list.length; i++) {
                    res.data.data.list[i].content = JSON.parse(res.data.data.list[i].content)
                  }
                  setTimeout(function () {
                    _this.loading = false
                    _this.rightImgList = _this.rightImgList.concat(res.data.data.list)
                    _this.totalNum = res.data.data.total
                  }, 1000)
                }
              })
          }
        } else if (
          (height == e.target.scrollTop || height - e.target.scrollTop === 1) &&
          height != 0 &&
          _this.leftMenuActiveIndex == -1
        ) {
          _this.getMoreMyUploadImg()
        }
      }
    },
    getMoreMyUploadImg() {
      const _this = this
      if (_this.pageNum < this.totalPage + 1) {
        _this.loading = true
        _this.pageNum++
        _this.instance
          .get(_this.contextPath + "v2/resource/query-my-upload", {
            params: {
              pageNum: _this.pageNum,
              pageSize: _this.pageSize
            }
          })
          .then(res => {
            if (res.data.code === 1) {
              for (let i = 0; i < res.data.data.list.length; i++) {
                res.data.data.list[i].content = JSON.parse(res.data.data.list[i].content)
              }
              setTimeout(function () {
                _this.loading = false
                _this.rightImgList = _this.rightImgList.concat(res.data.data.list)
                _this.totalNum = res.data.data.total
              }, 1000)
            }
          })
      }
    },
    toPs(item) {
      let url
      if (process.env.VUE_APP_MODE === "test" || process.env.NODE_ENV === "development") {
        url = "http://ps.mh.chaoxing.com/#/home"
      } else {
        url = "https://ps.mh.chaoxing.com/#/home"
      }
      let imgUrl
      if (item.content.url.indexOf("http") > -1) {
        imgUrl = encodeURI(encodeURI(item.content.url))
      } else {
        imgUrl = encodeURI(encodeURI("//static.mh.chaoxing.com" + item.content.url))
      }

      let from = encodeURI(encodeURI("2.0"))
      let name = encodeURI(encodeURI(item.name))
      window.open(`${url}?url=${imgUrl}&from=${from}&name=${name}`)
    }
  }
})
</script>

<style lang="scss" scoped>
/*图片上传出的样式*/
.upload {
  position: relative;
}
.upload .del-bg-icon {
  position: absolute;
  top: 4px;
  right: 4px;
  z-index: 10;
  cursor: pointer;
}
.content .upload {
  width: 90px;
  height: 90px;
}
.content .img-size-small {
  width: 90px;
  height: 90px;
}
.content .img-size-medium {
  width: 90px;
  height: 90px;
}
.content .upload img {
  width: 100%;
  height: 100%;
  border-radius: 4px;
  object-fit: cover;
}
.content .upload .del-bg-icon {
  position: absolute;
  display: none;
  bottom: 4px;
  top: auto;
  right: 4px;
  z-index: 10;
  cursor: pointer;
  width: 18px;
  line-height: 18px;
  text-align: center;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 3px;
  color: #ffffff;
}
.content .upload .del-bg-icon:hover {
  background: rgba(0, 0, 0, 0.8);
}
.content .upload:hover .del-bg-icon {
  display: block;
}
.upload-btns input[type="file"] {
  width: 38px;
}
.upload-btns span {
  cursor: pointer;
}
.el-select:hover .el-input__inner {
  border: none;
}
.el-color-dropdown .el-input__inner {
  background: #f7f7f7;
}
.content .description {
  font-size: 12px;
  line-height: 17px;
}
.img-boxs > li {
  display: inline-block;
  vertical-align: top;
  margin: 10px;
}
.img-boxs img {
  width: 130px;
  height: 74px;
  box-sizing: border-box;
  cursor: pointer;
}
.img-boxs img:hover {
  border: 1px solid rgba(8, 140, 223, 1);
}

.icon-boxs > li {
  display: inline-block;
  vertical-align: top;
  margin: 0 8px 8px 0;
}
.icon-boxs > li:nth-child(8n) {
  margin-right: 0;
}
.icon-box span {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 96px;
  height: 96px;
  text-align: center;
  box-sizing: border-box;
  /* font-size: 21px; */
  cursor: pointer;
  border: 1px solid transparent;
  border-radius: 8px;
}
::v-deep .icon-box span svg {
  width: 36px;
  height: 36px;
}
.icon-box span:hover {
  /* border: 2px solid var(--themeColor); */
  box-shadow: inset 0px 0px 0px 2px var(--themeColor);
}
::v-deep .imgResDialog {
  width: 1016px;
  max-height: 600px;
  border-radius: 8px;
  overflow: hidden;
  // border: 1px solid var(--borderColorFive);
}
::v-deep .imgResDialog .el-dialog__header {
  border-bottom: 1px solid var(--borderColorFive);
  padding: 18px 24px;
}
::v-deep .imgResDialog .el-dialog__body {
  display: flex;
  overflow: hidden;
  padding: 0 0 0 16px;
  box-sizing: border-box;
  height: 533px;
}
::v-deep .el-scrollbar__wrap {
  overflow-y: scroll;
  overflow-x: hidden;
  /* width: 110%; */
  height: 100%;
  // margin-right: 0 !important;
}
::v-deep .scrollbar {
  position: relative;
  height: calc(100% - 40px);
}
::v-deep .el-dialog__header .el-dialog__headerbtn {
  top: 18px;
  right: 24px;
}
::v-deep .el-dialog__headerbtn .el-dialog__close {
  /* color: rgba(0, 0, 0, 0.6); */
  color: var(--imgDialogIconColor);
  font-size: 20px;
}
.img-set-dialog-wrap {
  position: fixed;
  top: 0;
  right: 0;
  width: 300px;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 9999;
}
.img-set-dialog-wrap .img-set-dialog {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #ffffff;
  width: 210px;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid #e9e9e9;
  box-shadow: 0px 6px 16px -8px rgba(0, 0, 0, 0.08), 0px 9px 28px rgba(0, 0, 0, 0.05),
    0px 12px 48px 16px rgba(0, 0, 0, 0.03);
}
.img-set-dialog-wrap .dialog-header {
  position: relative;
  padding: 9.5px 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.07);
  height: 40px;
  line-height: 20px;
}
.img-set-dialog-wrap .dialog-header .dialog-title {
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: rgba(0, 0, 0, 0.8);
}
.img-set-dialog-wrap .dialog-header .icon-portal-close {
  position: absolute;
  right: 12px;
  top: 12px;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.6);
}
.img-set-dialog-wrap .dialog-body {
  padding: 16px 12px;
  height: 300px;
  overflow-y: auto;
}
.img-set-dialog-wrap .dialog-body .img-title {
  color: rgba(0, 0, 0, 0.6);
  font-size: 14px;
  line-height: 20px;
}
.img-set-dialog-wrap .dialog-body .img-boxs {
  margin-bottom: 16px;
  display: flex;
  flex-wrap: wrap;
}
.img-set-dialog-wrap .dialog-body .img-boxs:last-child {
  margin-bottom: 0;
}
.img-set-dialog-wrap .dialog-body .img-boxs > li {
  background: #ffffff;
  border: 1px solid #e9e9e9;
  box-sizing: border-box;
  border-radius: 4px;
  width: 40px;
  height: 40px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 8px 8px 0 0;
}
.img-set-dialog-wrap .dialog-body .img-boxs > li:nth-child(4n) {
  margin-right: 0;
}
.img-set-dialog-wrap .dialog-body .img-boxs img {
  width: 24px;
  height: 24px;
}
.img-set-dialog-wrap .dialog-body .img-boxs img:hover {
  border: none;
}
::v-deep .el-scrollbar__view {
  display: flex;
}
.imgResDialog .img-left-menu {
  position: relative;
  padding-right: 16px;
  padding-top: 16px;
  width: 150px;
  height: 100%;
  border-right: 1px solid rgba(0, 0, 0, 0.07);
  box-sizing: border-box;
}
.imgResDialog .img-left-menu .menu-item {
  cursor: pointer;
  padding: 10px 12px 10px 16px;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: var(--textColor);
  margin-bottom: 4px;
  border-radius: 8px;
}
.imgResDialog .img-left-menu .menu-item:hover {
  background: var(--inputIconHoverBgColor);
}
.imgResDialog .img-left-menu .menu-item.active {
  background: var(--themeColorSelectBg);
  border-radius: 8px;
  color: var(--themeColor);
  font-weight: 600;
}
.imgResDialog .left-menu-bottom-btns {
  position: absolute;
  left: 0px;
  right: 16px;
  bottom: 24px;
}
.imgResDialog .left-menu-bottom-btns .online-design-btn,
.imgResDialog .left-menu-bottom-btns .local-upload-btn {
  margin-top: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 36px;
  border: 1px solid var(--themeColor);
  border-radius: 8px;
  /* line-height: 34px; */
  font-size: 14px;
  color: var(--themeColor);
}
.imgResDialog .left-menu-bottom-btns .local-upload-btn {
  margin-top: 0;
  background: var(--themeColor);
  color: #fff;
}
.imgResDialog .left-menu-bottom-btns .local-upload-btn:hover {
  background: var(--primaryButtonHover);
  border: 1px solid var(--primaryButtonHover);
}
.imgResDialog .left-menu-bottom-btns .online-design-btn:hover {
  background: var(--defaultButtonHover);
}
.imgResDialog .left-menu-bottom-btns .online-design-btn i,
.imgResDialog .left-menu-bottom-btns .local-upload-btn i {
  margin-right: 4px;
  font-size: 20px;
}
.imgResDialog .img-right-list {
  flex: 1;
  padding: 16px 0 16px 16px;
  box-sizing: border-box;
}
.imgResDialog .img-right-list .right-catetory {
  position: relative;
  padding-right: 250px;
  // height: 40px;
  overflow: hidden;
}
.imgResDialog .img-right-list .right-catetory.isDown {
  height: auto;
}
.imgResDialog .img-right-list .right-catetory .slide-down-btn {
  cursor: pointer;
  position: absolute;
  top: 0;
  right: 16px;
  width: 20px;
  height: 28px;
  /* background: #f5f5f5; */
  background: var(--inputBackGround);
  border-radius: 2px;
  font-size: 12px;
  color: var(--imgDialogIconColor);
  text-align: center;
  line-height: 28px;
}
.imgResDialog .img-right-list .right-catetory.isDown .slide-down-btn i {
  display: inline-block;
  transform: rotate(180deg);
}
.imgResDialog .img-right-list .right-catetory .cate-item {
  cursor: pointer;
  // margin-right: 12px;
  margin-bottom: 8px;
  display: inline-block;
  vertical-align: top;
  padding: 0 12px;
  height: 36px;
  // background: var(--inputBackGround);
  border-radius: 8px;
  font-size: 14px;
  line-height: 36px;
  color: var(--textColor);
}
.imgResDialog .img-right-list .right-catetory .cate-item:hover {
  font-weight: 600;
}
.imgResDialog .img-right-list .right-catetory .cate-item.active {
  background: var(--inputBackGround);
  // color: var(--themeColor);
  font-weight: 600;
}
.imgResDialog .img-right-list .right-img-list {
  margin-top: 4px;
  width: 100%;
}
.imgResDialog .img-right-list .right-img-list::after {
  content: "";
  display: block;
  clear: both;
}
.imgResDialog .img-right-list .right-img-list .img-item-wrap {
  position: relative;
  cursor: pointer;
  margin: 0 8px 8px 0;
  /* float: left; */
  /*height: 176px;*/
  background: var(--leftMenuBgColor);
  border-radius: 8px;
  box-sizing: border-box;
  color: var(--thirdTextColor);
}
.imgResDialog .img-right-list .right-img-list .img-item {
  display: flex;
  align-items: center;
  justify-content: center;
  // padding: 8px 10px;
  /* width: 180px; */
  border-radius: 8px;
  margin-bottom: 4px;
  border: 1px solid rgba(0, 0, 0, 0.04);
}
.imgResDialog .img-right-list .right-img-list .img-item:hover {
  box-shadow: inset 0 0 0 2px #3d82f2;
}
.imgResDialog .img-right-list .right-img-list .img-item > img {
  max-width: 100%;
  max-height: 100%;
  border-radius: 4px;
}
.imgResDialog .img-right-list .right-img-list .img-item .img-msg-icon {
  cursor: pointer;
  display: none;
  position: absolute;
  left: 6px;
  top: 6px;
  width: 26px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  font-size: 13px;
  background-color: #fff;
  color: rgba(113, 121, 137, 1);
  border: 1px solid rgba(0, 0, 0, 0.07);
  border-radius: 6px;
  z-index: 1;
}
.imgResDialog .img-right-list .right-img-list .img-item:hover .img-msg-icon {
  display: block;
}
/* .imgResDialog .img-right-list .right-img-list .img-item .img-msg-icon:hover {
  background: url("../../assets/images/image-msg-black.png") no-repeat center center;
  background-size: contain;
} */
.imgResDialog .img-right-list .right-img-list .img-item .img-msg-icon:hover .img-msg-dialog {
  display: block;
}

.imgResDialog .img-right-list .right-img-list .img-item:nth-child(5n) .img-msg-dialog {
  right: -10px;
  left: auto;
  transform: translateX(0);
}

.imgResDialog .img-right-list .right-img-list .img-item .img-msg-delete {
  display: none;
  position: absolute;
  width: 26px;
  height: 26px;
  top: 6px;
  right: 6px;
  background: #ffffff;
  border-radius: 6px;
  color: #ff4e4e;
  font-size: 14px;
  text-align: center;
  line-height: 26px;
  border: 1px solid #ededed;
  z-index: 3;
}
.imgResDialog .img-right-list .right-img-list .img-item:hover .img-msg-delete {
  display: block;
}

.imgResDialog .img-right-list .right-empty-list {
  margin-top: 150px;
  text-align: center;
}
/* .imgResDialog .img-right-list .right-empty-list p {
  display: block;
} */
.imgResDialog .img-msg-dialog {
  display: none;
  position: absolute;
  top: 26px;
  left: 0;
  // transform: translateX(-50%);
  width: 200px;
  height: 128px;
  background: var(--leftMenuBgColor);
  border: 1px solid var(--messageTipsBorderColor);
  box-shadow: 0px 6px 16px -8px rgba(0, 0, 0, 0.08), 0px 8px 20px rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  box-sizing: border-box;
  z-index: 2;
}
.imgResDialog .img-msg-dialog .img-name {
  margin-bottom: 0px;
  padding: 12px;
  font-weight: 600;
  font-size: 14px;
  line-height: 16px;
  color: var(--textColor);
  border-bottom: 1px solid var(--messageTipsBorderColor);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.imgResDialog .img-msg-dialog .img-msg-box {
  padding: 12px;
  box-sizing: border-box;
  text-align: left;
}
.imgResDialog .img-msg-dialog .msg-item {
  margin-bottom: 8px;
  height: 16px;
}
.imgResDialog .img-msg-dialog .msg-item .msg-t {
  display: inline-block;
  vertical-align: top;
  width: 44px;
  font-size: 14px;
  line-height: 16px;
  color: var(--subTextColor);
}
.imgResDialog .img-msg-dialog .msg-item .msg-v {
  display: inline-block;
  vertical-align: top;
  width: 130px;
  font-size: 14px;
  line-height: 16px;
  color: var(--textColor);
}
.imgResDialog .dialog-header {
  display: flex;
  align-items: center;
}
.imgResDialog .dialog-header .dialog-title {
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  color: var(--textColor);
}
.imgResDialog .dialog-header .search-box {
  margin-left: 367px;
  position: relative;
  display: flex;
  align-items: center;

  width: 320px;
  height: 30px;
  background: var(--inputBackGround);
  border-radius: 4px;
  box-sizing: border-box;
}

.imgResDialog .dialog-header .search-box:hover {
  background: var(--inputNuberHoverThemeBgColor);
}
.imgResDialog .dialog-header .search-box > input {
  width: 100%;
  height: 100%;
  background: transparent;
  color: var(--textColor);
  padding: 6px 50px 6px 12px;
  border-radius: 4px;
}
.imgResDialog .dialog-header .search-box > input::placeholder {
  color: var(--fourthTextColor);
}
.imgResDialog .dialog-header .search-box > input:focus {
  box-shadow: inset 0px 0px 0px 2px var(--themeColor);
}
.imgResDialog .dialog-header .search-box .clear-btn {
  /* display: none; */
  cursor: pointer;
  position: absolute;
  top: 7px;
  right: 31px;
  font-size: 16px;
  color: var(--fourthTextColor);
}
.imgResDialog .dialog-header .search-box .clear-btn:hover {
  color: var(--imgDialogIconColor);
}
.imgResDialog .dialog-header .search-box .search-btn {
  cursor: pointer;
  position: absolute;
  top: 7px;
  right: 9px;
  font-size: 16px;
  color: var(--imgDialogIconColor);
}
.imgResDialog .dialog-header .search-box .search-btn:hover {
  color: var(--themeColor);
}
/* 分页 */
.el-pagination {
  text-align: center;
}
::v-deep .el-pagination button,
.el-pagination span:not([class*="suffix"]),
::v-deep .el-pager li {
  height: 24px;
  line-height: 24px;
}
::v-deep .el-pagination.is-background .btn-next,
::v-deep .el-pagination.is-background .btn-prev,
::v-deep .el-pagination.is-background .el-pager li {
  min-width: 28px;
  height: 28px;
  line-height: 28px;
}
::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: var(--themeColor);
}
::v-deep .el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: var(--themeColor);
}
.to-ps {
  display: none;
  position: absolute;
  top: 6px;
  right: 6px;
  width: 26px;
  text-align: center;
  height: 26px;
  line-height: 26px;
  border-radius: 6px;
  border: 1px solid rgba(0, 0, 0, 0.07);
  background-color: #fff;
  color: rgba(113, 121, 137, 1);
  font-size: 13px;
  cursor: pointer;
}
.imgResDialog .img-right-list .right-img-list .img-item:hover .img-msg-icon,
.imgResDialog .img-right-list .right-img-list .img-item:hover .to-ps {
  display: block;
}
.imgResDialog .img-right-list .right-img-list .img-item .img-msg-icon:hover,
.imgResDialog .img-right-list .right-img-list .img-item .to-ps:hover {
  color: var(--themeColor);
}
.imgResDialog .img-right-list .right-catetory .right-filter .el-select {
  width: 100px;
}
::v-deep .imgResDialog {
  .img-right-list {
    .right-catetory {
      .right-filter {
        position: absolute;
        right: 16px;
        display: flex;
        .filter-box {
          position: relative;
          margin-left: 12px;
          &.color-set {
            .text {
              position: absolute;
              right: 12px;
              top: 50%;
              transform: translateY(-50%);
              color: var(--textColor);
              font-weight: 600;
              font-size: 14px;
            }
            .color-picker-container {
              height: 36px;
              border: none !important;
            }
          }
          .icon {
            position: absolute;
            font-size: 16px;
            z-index: 2;
            top: 50%;
            transform: translateY(-50%);
            left: 12px;
            color: var(--textColor);
          }
          .el-select {
            width: 100px;
            .el-input__inner {
              padding-left: 34px;
              padding-right: 30px;
              background-color: var(--leftMenuBgColor);
              border-radius: 8px;
              border: 1px solid var(--sliderBackGround);
              font-weight: 600;
              color: var(--textColor);
              height: 36px;
              line-height: 36px;
              &:focus {
                border-color: var(--inputBackGround) !important;
                background: var(--inputBackGround);
              }
              &::placeholder {
                color: var(--textColor);
                font-weight: 600;
              }
              &:hover {
                background: var(--inputBackGround);
              }
            }
            .el-icon-arrow-up {
              display: inline-block;
              width: 14px;
              height: 14px;
              background: url(../../assets/images/triangle-down-one.png) no-repeat;
              background-size: 100%;
              position: relative;
              transform: rotate(0deg);
              &:before {
                display: none;
              }
            }
            .el-icon-circle-close {
              display: inline-block;
              width: 14px;
              height: 14px;
              background: url(../../assets/images/close-one.png) no-repeat;
              background-size: 100%;
              position: relative;
              &:before {
                display: none;
              }
            }
            .el-input__suffix-inner {
              line-height: 36px;
            }
          }
          .color-img {
            position: absolute;
            width: 16px;
            height: 16px;
            z-index: 2;
            top: 50%;
            transform: translateY(-50%);
            left: 12px;
          }
          .color-ball {
            display: inline-block;
            position: absolute;
            width: 16px;
            height: 16px;
            border-radius: 16px;
            z-index: 2;
            top: 50%;
            transform: translateY(-50%);
            left: 12px;
            border: 1px solid #ededed;
          }
          .color-picker {
            width: 74px;
            .text_color_in_input {
              display: none;
            }
            .el-color-picker__color {
              border-radius: 50%;
            }
            .el-color-picker__color-inner {
              border-radius: 50%;
            }
          }
        }
      }
    }
  }
}
::v-deep .icon-box svg * {
  stroke: var(--iconColor);
}
.loading {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 16px;
  line-height: 32px;
  color: var(--thirdTextColor);
  i {
    display: inline-block;
    vertical-align: top;
    font-size: 32px;
  }
}
.iconpark-tips {
  margin-bottom: 16px;
  font-size: 12px;
  line-height: 17px;
  color: var(--thirdTextColor);
  text-align: center;
}
.iconpark-tips span {
  color: var(--themeColor);
}
</style>
<style>
.el-select-dropdown.filter .el-select-dropdown__list {
  background-color: var(--leftMenuBgColor) !important;
  border: 1px solid var(--sliderBackGround);
}
.el-select-dropdown.filter .el-select-dropdown__list .el-select-dropdown__item {
  color: var(--textColor) !important;
}
.el-select-dropdown.filter .el-select-dropdown__list .el-select-dropdown__item.selected {
  color: var(--themeColor) !important;
}
.el-select-dropdown.color-box {
  width: 192px;
  /* border: 1px solid var(--sliderBackGround); */
  box-shadow: 0 6px 16px -8px rgb(0 0 0 / 8%), 0 8px 20px rgb(0 0 0 / 12%);
  border-radius: 4px;
}
.el-select-dropdown.color-box .el-select-dropdown__list {
  overflow: hidden;
  padding: 12px;
  border-radius: 4px;
}
.el-select-dropdown.color-box .el-select-dropdown__list .el-select-dropdown__item {
  float: left;
  margin-right: 11px;
  height: 24px;
  border-radius: 99px;
  margin-bottom: 14px;
  padding: 0;
}
.el-select-dropdown.color-box .el-select-dropdown__list .el-select-dropdown__item:nth-child(5n) {
  margin-right: 0;
}
.el-select-dropdown.color-box .el-select-dropdown__list .el-select-dropdown__item .color-solid {
  display: inline-block;
  width: 24px;
  height: 24px;
  border-radius: 24px;
  box-sizing: border-box;
  border: 1px solid #ededed;
}
.el-select-dropdown.color-box .el-select-dropdown__list .el-select-dropdown__item.selected .color-solid {
  border: 1px solid #ffffff;
}
.el-select-dropdown.color-box .el-select-dropdown__list .el-select-dropdown__item.selected {
  box-shadow: 0px 0px 0px 2px var(--themeColor);
}
.el-select-dropdown.color-box .el-select-dropdown__list .el-select-dropdown__item:hover .color-solid {
  border: 1px solid #ffffff;
}
.el-select-dropdown.color-box .el-select-dropdown__list .el-select-dropdown__item:hover {
  box-shadow: 0px 0px 0px 2px rgba(61, 130, 242, 0.5);
}
</style>
